export default __webpack_public_path__ + "c844cea3f25b0292a18332e108e52601.svg";